import axios from '@/services/axios';

import {useLoadingStore} from '@/stores/loadingStore.js';

export default{
    async getAllCompanies(){
        const loadingStore = useLoadingStore();
        try {
            loadingStore.setLoading(true);
            loadingStore.setLoadingMessage('getAllCompanies');

            const response = await axios().get("/companies");

            loadingStore.setLoading(false);
            
            return response;
          } catch (error) {
            
        }
    },

    async getMy(){
        try {
            return await axios().get("/companies/my");
          } catch (error) {
            
        }
    },

    async getActiveContact(companyId){
        const loadingStore = useLoadingStore();
        try{
            return await axios().get(`/companies/${companyId}/active_contact`);
        }catch (error) {
            
        }
    },

    async getCompanyContacts(companyId, page = 1, limit = 10, filters = {}){
        const loadingStore = useLoadingStore();
        try{
            const response = await axios().get(`/companies/${companyId}/contacts?page=${page}&limit=${limit}&${Object.entries(filters).map(([key, value]) => (value == 0 || value) ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}` : '').join('&')}`);

            return response;
        }catch (error) {
            
        }
    },

    async addCompany(company){
        const loadingStore = useLoadingStore();
        try {
            loadingStore.setLoading(true);
            loadingStore.setLoadingMessage('addCompany');
            

            const response = await axios().post("/companies", company);

            loadingStore.setLoading(false);           
            
            return response;
          } catch (error) {
            
        }
    },

    async updateCompany(companyId, company){
        const loadingStore = useLoadingStore();
        try{
            loadingStore.setLoading(true);
            loadingStore.setLoadingMessage('updateCompany');
            

            const response = await axios().put(`/companies/${companyId}`, company);

            loadingStore.setLoading(false);           
            
        }
        catch(error){
            
        }
    },

    async removeCompany(companyId){
        const loadingStore = useLoadingStore();
        try {
            loadingStore.setLoading(true);
            loadingStore.setLoadingMessage('removeCompany');

            const response = await axios().delete(`/companies/${companyId}`);

            loadingStore.setLoading(false);
            
            return response;
          } catch (error) {
            
        }
    },

    async getCompanyById(companyId){
        const loadingStore = useLoadingStore();
        try {
            return await axios().get(`/companies/${companyId}`);
          } catch (error) {
            
        }
    },

    async getPermissionByCompanyId(companyId){
        const loadingStore = useLoadingStore();
        try {
            return await axios().get(`/companies/${companyId}/permissions`);
          } catch (error) {
            
        }
    },

    async getUsersByCompanyId(companyId){
        const loadingStore = useLoadingStore();
        try {
            loadingStore.setLoading(true);
            loadingStore.setLoadingMessage('getUsersByCompanyId');

            const response = await axios().get(`/companies/${companyId}/users`);

            loadingStore.setLoading(false);
            
            return response;
          } catch (error) {
            
        }
    },

    async getRequesitByCompanyId(companyId){
        const loadingStore = useLoadingStore();
        try {
            return await axios().get(`/companies/${companyId}/bank_requesits`);
          } catch (error) {
            
        }
    },

    async getCustomersByCompanyId(companyId){
        const loadingStore = useLoadingStore();
        try {
            loadingStore.setLoading(true);
            loadingStore.setLoadingMessage('getCustomersByCompanyId');

            const response = await axios().get(`/companies/${companyId}/customers`);

            loadingStore.setLoading(false);
            
            return response;
          } catch (error) {            
        }
    },

    async getProcurementRulesByCompanyId(companyId){
        const loadingStore = useLoadingStore();
        try {
            loadingStore.setLoading(true);
            loadingStore.setLoadingMessage('getProcurementRulesByCompanyId');

            const response = await axios().get(`/companies/${companyId}/procurement_rules`);

            loadingStore.setLoading(false);
            
            return response;
          } catch (error) {            
        }
    },

    async searchInDadata(params) {
        const loadingStore = useLoadingStore();

        try {
            loadingStore.setLoading(true);
            loadingStore.setLoadingMessage('getInfoByInn - started');

            const response = await axios().get(`/companies/dadata/search`, {params});

            loadingStore.setLoadingMessage('getInfoByInn - success');

            return response.data;
        } catch (error) {
            loadingStore.setLoadingMessage('getInfoByInn - failed');
        } finally {
            loadingStore.setLoading(false);
        }
    }
}